import { Button, Drawer, IconButton, Typography } from '@mui/material';
import PropTypes from 'prop-types';
// import { useshelfActions } from 'src/context/providers/shelfContext';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
import { useShelfActions } from 'src/context/providers/ShelfContext';
import ComboBox from 'src/custom_components/Froms/comboBoxAutocomplite';
import InputFieds from '../../custom_components/Froms/InputFields';
import { personalInformation, TypesForSelect } from './view/data';

const CreateShelfDrawer = ({ isDrawerOpen, handleDrawerToggle }) => {
  const [shelfData, setshelfData] = useState({
    code: '',
    name: '',
    shelfType: '',
  });
  const { createShelf } = useShelfActions();

  const Clear = () => {
    setshelfData({});
  };

  const handleCreateshelf = async () => {
    const shelfData1 = {
      code: shelfData.code,
      name: shelfData.code,
      shelfType: shelfData.shelfType,
    };
    await createShelf(shelfData1);
    Clear();
    handleDrawerToggle();
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setshelfData({
      ...shelfData,
      [name]: value,
    });
  };

  const DrawerConfig = {
    SubNavigation: true,
    anchor: 'right',
    width: '35%',
    drawerHeaderText: 'Create Shelf',
    buttons: {
      status: true,
      elements: [{ name: 'Create', onClick: handleCreateshelf }],
    },
  };

  const containerStyle = {
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    position: 'fixed',
    zIndex: 2,
    top: 0,
    left: 0,
    display: isDrawerOpen ? 'block' : 'none',
    cursor: 'pointer',
  };

  const handleOutsideClick = (event) => {
    if (event.target === event.currentTarget) {
      handleDrawerToggle();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      style={containerStyle}
      onKeyDown={(event) => {
        if (event.key === 'Escape') {
          handleDrawerToggle();
        }
      }}
      onClick={handleOutsideClick}
    >
      <Drawer
        variant="persistent"
        anchor={DrawerConfig.anchor}
        open={isDrawerOpen}
        onClose={handleDrawerToggle}
        PaperProps={{
          sx: { width: { lg: DrawerConfig.width, xs: '100%', md: '100%' } },
        }}
      >
        {/* Drawer Content */}

        {/* Header */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px',
            borderBottom: '1px solid rgba(220, 220, 220, 0.2)',
          }}
        >
          <Typography variant="h6">{DrawerConfig.drawerHeaderText}</Typography>
          <div
            style={{
              width: '10%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {/* <TextField
              name="status"
              label="status"
              value={shelfData[status]}
              defaultValue={status[0]}
              onChange={handleInputChange}
              variant="filled"
              sx={{ minWidth: '80%' }}
              select
            >
              {status.map((i, ind) => (
                <MenuItem key={ind} value={i}>
                  {i}
                </MenuItem>
              ))}
            </TextField> */}
            <IconButton onClick={handleDrawerToggle}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>

        {/* Form */}
        <div
          className="content-wrap"
          style={{
            gap: '2px',
            padding: '30px 0px 0px 0px',
            alignItems: 'center',
            justifyContent: 'space-evenly',
          }}
        >
          {/* Form */}

          {/* Personal Information */}
          <InputFieds
            userData={shelfData}
            heading="Shelf Information"
            inputFields={personalInformation}
            setUserData={setshelfData}
          />
          {/* Personal Information */}

          <div
            className="content-wrap"
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              padding: '5px 0px 20px 20px',
            }}
          >
            <ComboBox
              nameOfInput="shelfType"
              data={TypesForSelect}
              setter={handleInputChange}
              value={shelfData.shelfType}
            />
          </div>
        </div>

        {/* Buttons */}
        {DrawerConfig.buttons && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              borderTop: '1px solid rgba(220, 220, 220, 0.2)',
              padding: '16px',
              position: 'absolute',
              bottom: '0',
              left: '0',
              width: '100%',
            }}
          >
            {DrawerConfig.buttons.elements.map((element, index) => (
              <Button
                variant="contained"
                key={index}
                style={{
                  marginLeft: '24px',
                  width: '136px',
                }}
                onClick={element.onClick}
              >
                Create
              </Button>
            ))}
          </div>
        )}
      </Drawer>
    </div>
  );
};

CreateShelfDrawer.propTypes = {
  isDrawerOpen: PropTypes.bool.isRequired,
  handleDrawerToggle: PropTypes.func.isRequired,
};

export default CreateShelfDrawer;
